import {firmaEntitiesAdapter} from './firma-entities.adapter';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {FirmaEntitiesState} from './firma-entities.state';
import {FirmaDTO} from '../../openapi/export-openapi';
import {SelectorCache} from '../utils/selector-cache.util';


export const FIRMA_ENTITIES_FEATURE_KEY = 'firmaEntities';

export class FirmaEntitiesSelectors {

  private static readonly _adapterSelectors = firmaEntitiesAdapter.getSelectors();

  private static readonly _feature = createFeatureSelector<FirmaEntitiesState>(FIRMA_ENTITIES_FEATURE_KEY);
  
  // Cache für memoized Selektoren mit Utility
  private static readonly _selectorCache = new SelectorCache<FirmaDTO | undefined>();

  public static readonly all = createSelector(
    this._feature,
    this._adapterSelectors.selectAll,
  );

  public static readonly firmaById = (firmenId: string | undefined) => {
    // Kein firmenId? Gib undefined Selector zurück
    if (!firmenId) {
      return createSelector(
        this._feature,
        () => undefined
      );
    }
    
    // Nutze die SelectorCache Utility
    return this._selectorCache.getOrCreate(
      `firma_${firmenId}`,
      () => createSelector(
        this._feature,
        (state) => this._adapterSelectors.selectEntities(state)[firmenId] ?? undefined
      )
    );
  };

}
